"use client";

import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import ProgramBuildingModal from "../../components/forms/program-building-modal";

const ProgramBuildingPage: React.FC = () => {
	const [modalOpen, setModalOpen] = useState(false);
	const router = useRouter();

	useEffect(() => {
		setModalOpen(true);
	}, []);

	const handleCloseModal = () => {
		setModalOpen(false);
		router.push("/");
	};

	return (
		<>
			<div className="flex items-center justify-center min-h-screen">
				<div className="text-center">
					<h1 className="text-xl font-semibold mb-4">
						Tư vấn Xây dựng chương trình
					</h1>
					<p className="text-gray-600 mb-4">
						Mở form tư vấn xây dựng chương trình...
					</p>
				</div>
			</div>

			<ProgramBuildingModal open={modalOpen} onClose={handleCloseModal} />
		</>
	);
};

export default ProgramBuildingPage;
